import React from "react";
import chat from "@/assets/img/icons/Chat.svg";
import settings from "@/assets/img/icons/Setting.svg";
interface NavigationButtonsProps {
  onNavigateToChat: () => void;
  onOpenSettings: () => void;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({ 
  onNavigateToChat, 
  onOpenSettings 
}) => (
  <div
    className="flex flex-row items-end justify-end w-full"
    style={{ gridRow: "1", gridColumn: "1/3" }}
  >
    <button
      className="flex items-center justify-center p-2"
      onClick={onNavigateToChat}
    >
      <img src={chat} className="w-5 h-5 mr-2" alt="Chat" />
    </button>
    <button
      className="flex items-center justify-center p-2"
      onClick={onOpenSettings}
    >
      <img src={settings} className="w-5 h-5 mr-2" alt="Settings" />
    </button>
  </div>
); 